import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import useVenue from "../../hooks/useVenue";

import * as styles from "./styles.module.scss";

const BoardItem = ({ text, small, inverse, style }) => {
  const { isBexley, isEltham } = useVenue();

  const className = classNames(styles.boardItem, {
    [styles.bexley]: isBexley,
    [styles.eltham]: isEltham,
    [styles.small]: small,
    [styles.subtle]: style === "subtle",
    [styles.menu]: style === "menu",
    [styles.inverse]: inverse,
  });

  return <div className={className}>{text}</div>;
};

BoardItem.propTypes = {
  text: PropTypes.text,
  small: PropTypes.bool,
  style: PropTypes.string,
  inverse: PropTypes.string,
};

export default BoardItem;
